import { Button, Divider, Flex, notification } from "antd";
import MovimentacaoFormBasic, { IMovimentacaoFormBasicRef, IMovimentacaoFormBasicProps } from "./MovimentacaoFormBasic";
import dayjs from "dayjs";
import { ReactElement, useEffect, useRef } from "react";
import { useMovimentacaoSalvar } from "../../../../../Services/Financeiro/Conta/MovimentacaoService";
import { Movimentacao } from "../../../../../Models/Financeiro/Conta/Movimentacao";
import { AxiosResponse } from "axios";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";

export interface IMovimentacaoFormProps extends Omit<IMovimentacaoFormBasicProps, "onFinish"> {
    buttoCencelar?: ReactElement;
    onCancelar?: (evento: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSuccess?:(response:AxiosResponse<void, any>, input:Movimentacao) => void;
}
export default function MovimentacaoForm({
    buttoCencelar,
    onCancelar,
    onSuccess,
    ...props
}:IMovimentacaoFormProps) {
    const refForm = useRef<IMovimentacaoFormBasicRef|null>(null);

    const {
        mutate,
        isPending
    } = useMovimentacaoSalvar({
        onSuccess(data, variables) {
            onSuccess?.(data, variables);
            onCancelar?.({} as any);
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Movimentação salva com sucesso."
            });
        },
    });

    return <>
        <MovimentacaoFormBasic 
            {...props}
            ref={refForm}
            onFinish={(data) => {
                mutate(data.movimentacao);
            }}
        />
        
        <Divider />

        <Flex gap="small" wrap="wrap" justify="center">
            {!!buttoCencelar && buttoCencelar}
            {!!!buttoCencelar && !!onCancelar && (
                <Button type="primary" danger htmlType="reset" onClick={onCancelar}>
                    Cancelar
                </Button>
            )}
            <Button type="primary" onClick={() => refForm.current?.submit()} loading={isPending}>
                Salvar
            </Button>
        </Flex>
    </>;
}